import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { environment } from "../../../../environments/environment";
import { CommonService } from '../../shared/services/common.service';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ChatService {

  public APIEndpoint = environment.baseUrl
  private dataSubject = new BehaviorSubject<any>('');
  dataChatCount$ = this.dataSubject.asObservable();

  constructor(
    private http: HttpClient,
    private _commonService: CommonService
  ) { }

  updateChatCount(data: any) {
    this.dataSubject.next(data);
  }
  
  public getChatList(params) {
    return this.http.post(`${this.APIEndpoint}api/auth/chat-list`, params)
      .pipe(map((response: Response) => {
        let responseAny: any = response;
        return responseAny;
      }),
        catchError((err: any) => {
          throw (err)
        })
      );
  }

  public getChatDetails(params) {
    return this.http.post(`${this.APIEndpoint}api/auth/chat-detail`, params)
      .pipe(map((response: Response) => {
        let responseAny: any = response;
        return responseAny;
      }),
        catchError((err: any) => {
          throw (err)
        })
      );
  }

  public sendMessageChat(params) {
    return this.http.post(`${this.APIEndpoint}api/auth/send-message-to-user`, params)
      .pipe(map((response: Response) => {
        let responseAny: any = response;
        return responseAny;
      }),
        catchError((err: any) => {
          throw (err)
        })
      );
  }

  public changeStatusReadChat(params) {
    return this.http.post(`${this.APIEndpoint}api/auth/message-status-change`, params)
      .pipe(map((response: Response) => {
        let responseAny: any = response;
        return responseAny;
      }),
        catchError((err: any) => {
          throw (err)
        })
      );
  }


  
}